<template>
  <div class="mb-1 d-flex justify-space-between align-center" >
    <v-text-field
        v-model="form.username"
        :density="settings.density"
        :flat="settings.is_flat"
        :hide-details="settings.is_details_hidden"
        :rounded="settings.rounded"
        :single-line="settings.is_single_line"
        :variant="settings.variant"
    >
      <span class="font-weight-bold">Заявитель: </span>
    </v-text-field>
    <v-responsive max-width="300">
      <v-select
          class="ml-1"
          :items="priorities"
          v-model="form.priority"
          :density="settings.density"
          :flat="settings.is_flat"
          :hide-details="settings.is_details_hidden"
          :rounded="settings.rounded"
          :single-line="settings.is_single_line"
          :variant="settings.variant"
          item-value="id"
          item-title="name"
      >
        <template v-slot:label>
          <span class="font-weight-bold">Приоритет: </span>
        </template>
      </v-select>
    </v-responsive>
  </div>
  <v-text-field
      class="mb-1"
      v-model="form.qualification"
      :density="settings.density"
      :flat="settings.is_flat"
      :hide-details="settings.is_details_hidden"
      :rounded="settings.rounded"
      :single-line="settings.is_single_line"
      :variant="settings.variant"
  >
    <span class="font-weight-bold">Должность: </span>
  </v-text-field>
  <v-text-field
      class="mb-1"
      v-model="form.district"
      :density="settings.density"
      :flat="settings.is_flat"
      :hide-details="settings.is_details_hidden"
      :rounded="settings.rounded"
      :single-line="settings.is_single_line"
      :variant="settings.variant"
  >
    <span class="font-weight-bold">Участок: </span>
  </v-text-field>
  <v-textarea
      class="mb-1"
      v-model="form.description"
      :density="settings.density"
      :flat="settings.is_flat"
      :hide-details="settings.is_details_hidden"
      :rounded="settings.rounded"
      :single-line="settings.is_single_line"
      :variant="settings.variant"
  >
    <template v-slot:label>
      <span class="font-weight-bold">Опишите проблему: </span>
    </template>
  </v-textarea>
  <v-divider />
  <v-alert class="rounded-t-xl rounded-b-0" border="bottom" border-color="green">
    <template v-slot:title>
      <p class="text-center font-weight-bold" style="width: 100%">ПРИЛОЖЕНИЯ</p>
    </template>
  </v-alert>
  <v-sheet
      color="grey-lighten-4"
      v-if="files.length === 0"
      id="my-drag-drop"
      border="2"
      rounded="xl"
      style="min-width: 300px; min-height: 170px"
      class="d-flex align-center justify-center drop-area rounded-t-0 rounded-b-xl"
      @dragover="dragover($event)"
      @dragleave="dragleave($event)"
      @drop="drop($event)"
      @click="openSelector()"
  >
    <div>
      Перетащи файл сюда <v-icon :icon="['fas', 'cloud-arrow-up']" />
    </div>
  </v-sheet>
  <v-card v-if="files.length > 0" variant="outlined" class="drop-area" rounded="xl">
    <template v-slot:title>
      Загруженные файлы
    </template>
    <template v-slot:text>
      <div id="list_images" />
    </template>
    <template v-slot:actions>
      <v-btn rounded="xl" color="brown" v-on:click="files = []">ЕЩЁ РАЗ</v-btn>
      <v-spacer />
      <v-btn rounded="xl" color="light-green">ПРИМЕНИТЬ</v-btn>
    </template>
  </v-card>
</template>

<script>
import { UserStore } from "@/store/GigaUser";
import getIMG from "@/libs/getIMG";

export default {
  name: "MessageBugReport",
  beforeMount() {
    this.form.username = this.user.name
    this.form.district = this.user.district_name
    this.form.qualification = this.user.qualification_name
  },
  data() {
    return {
      files: [],
      settings: {
        is_flat: true,
        variant: 'solo-filled',
        rounded: 'xl',
        is_single_line: true,
        is_details_hidden: true,
        density: 'compact'
      },
      form: {
        username: null,
        district: null,
        qualification: null,
        description: null,
        priority: null
      },
      priorities: [
        {
          name: 'Низкий',
          id: 'low',
          color: '#dadada'
        },
        {
          name: 'Обычный',
          id: 'middle',
          color: '#92ee76'
        },
        {
          name: 'Высокий',
          id: 'high',
          color: '#ee8876'
        },
        {
          name: 'Мега-КРИТИЧНЫЙ',
          id: 'zupper_high',
          color: '#8f0930'
        }
      ]
    }
  },
  methods: {
    load_images: async function () {
      let block = document.getElementById('list_images')
      for (let file of this.files) {
        let src = await getIMG(file)
        console.log(block, src)
        //await block.appendChild(src)
      }
    },
    apply_files: async function (files) {
      this.files = files
      await this.load_images()
    },
    openSelector: function () {
      let input = document.createElement('input')
      input.type = 'file'
      input.multiple = true
      input.onchange = (e) => {
        this.apply_files(e.target.files)
      }
      input.click()
    },
    dragover: function (event) {
      let div = document.getElementById('my-drag-drop')
      div.classList.add('hovered')
      event.preventDefault()
    },
    dragleave: function (event) {
      let div = document.getElementById('my-drag-drop')
      div.classList.remove('hovered')
      event.preventDefault()
    },
    drop: function (ev) {
      ev.preventDefault()
      this.apply_files(ev.dataTransfer.files)
    }
  },
  computed: {
    user: {
      get() {
        return UserStore().get()
      },
      set(value) {
        UserStore().set(value)
      }
    },
  }
}

</script>

<style>
.drop-area {
  border-radius: 5px;
  border: 1px dashed #dadada;
}
</style>
